<template>
  <BaseModal
    @close="close"
    @commit="commit"
    :lang="lang"
    :showLogo="false"
    class="modal-sendbp"
    :style="styleModal"
  >
    <div class="modal-sendbp-container" :style="`width:${width}`">
      <Close class="modal-sendbp-close" @click="close"></Close>
      <div slot="header" class="modal-sendbp-header">
        <div class="modal-sendbp-header-desc" @click="showDesc=true" v-if="!showDesc">
          <div class="modal-sendbp-header-desc-text">投递说明</div>
          <div class="modal-sendbp-header-desc-arrow"></div>
        </div>
        <Flow123 class="modal-sendbp-header-flow" :step="step_"></Flow123>
      </div>
      <div slot="body" class="modal-sendbp-body">
        <div v-if="step_===1 && list.length<=0" class="modal-sendbp-body-bg"></div>
        <div v-if="step_===1 && list.length<=0" class="modal-sendbp-body-create">你还没有创建BP</div>
        <div v-if="step_===1 && list.length>0" class="modal-sendbp-body-select">
          <div v-for="(row, i) in list" :key="i" class="modal-sendbp-body-select-item">
            <Avatar username="avatar" :src="row.index_thumbnail_url" :size="50" :rounded="false" class="modal-sendbp-body-select-item-img"></Avatar>
            <div class="modal-sendbp-body-select-item-desc">
              <div class="modal-sendbp-body-select-item-desc-title">{{row.name ? row.name : '请输入项目名称'}}</div>
              <div class="modal-sendbp-body-select-item-desc-time">{{row.update_time | date}}</div>
            </div>
            <div class="modal-sendbp-body-select-item-check">
              <input type="radio" :value="i" v-model="selectedIndex" />
            </div>
          </div>
        </div>
        <div v-if="step_===2">
          <div class="modal-sendbp-body-title">{{lang.step2}}</div>
          <div class="modal-sendbp-body-input">
            <div class="modal-sendbp-body-input-title">
              <span class="modal-sendbp-body-input-title-star">*</span>
              <span>{{lang.username}}</span>
            </div>
            <BaseInput v-model="input.username" :placeholder="`请输入${lang.username}`" height="36px"></BaseInput>
          </div>
          <div class="modal-sendbp-body-input">
            <div class="modal-sendbp-body-input-title">
              <span class="modal-sendbp-body-input-title-star">*</span>
              <span>{{lang.mobile}}</span>
            </div>
            <BaseInput v-model="input.mobile" type="tel" :placeholder="`请输入${lang.mobile}`" height="36px"></BaseInput>
          </div>
          <div class="modal-sendbp-body-input">
            <div class="modal-sendbp-body-input-title">
              <span class="modal-sendbp-body-input-title-star">*</span>
              <span>{{lang.weixin}}</span>
            </div>
            <BaseInput v-model="input.weixin" :placeholder="`请输入${lang.weixin}`" height="36px"></BaseInput>
          </div>
          <div class="modal-sendbp-body-input">
            <div class="modal-sendbp-body-input-title">
              <span class="modal-sendbp-body-input-title-star">*</span>
              <span>{{lang.email}}</span>
            </div>
            <BaseInput v-model="input.email" :placeholder="`请输入${lang.email}`" height="36px"></BaseInput>
          </div>
        </div>
        <div v-if="step_===3">
          <div class="modal-sendbp-body-title">{{lang.step3}}</div>
          <div class="modal-sendbp-body-input2">
            <div class="modal-sendbp-body-input2-title">
              <span class="modal-sendbp-body-input2-title-star">*</span>
              <span>{{lang.p_name}}</span>
            </div>
            <BaseInput v-model="input.p_name" :placeholder="`请输入${lang.p_name}`" width="340px" height="36px"></BaseInput>
          </div>
          <div class="modal-sendbp-body-input2">
            <div class="modal-sendbp-body-input2-title">
              <span class="modal-sendbp-body-input2-title-star">*</span>
              <span>{{lang.desc}}</span>
            </div>
            <BaseInput v-model="input.desc" type="tel" :placeholder="'请介绍一下自己'" width="340px" height="80px"></BaseInput>
          </div>
          <div class="modal-sendbp-body-upload">
            <div class="modal-sendbp-body-upload-files">
              <div v-for="(file, i) in temp.attachments" :key="i" class="modal-sendbp-body-upload-files-file">
                <span>{{file.name}}</span>
                <i v-if="!file.uploaded" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                <i
                  v-if="file.uploaded"
                  class="icon-pr_phone_icon_preference_delete red"
                  @click="deleteTempAtt(file, i)"
                ></i>
              </div>
            </div>
            <BaseButton5
              class="modal-sendbp-body-upload-button"
              @click="emitUpload"
            >{{lang.upload}}</BaseButton5>
            <input class="invisible" type="file" accept="*/*" id="modal-sendbp-body-upload-files-file" @change="addTempAtt">
          </div>
          <!-- <div class="modal-sendbp-body-private">
            <div class="modal-sendbp-body-private-title">
              <span>私密提问</span>
              <span>10</span>
              <span>元</span>
            </div>
            <div class="modal-sendbp-body-private-desc">（私密提问的问题将不公开在投资人详情页）</div>
            <div class="modal-sendbp-body-private-check">
              <input type="checkbox" v-model="input.private" />
            </div>
          </div> -->
          <div class="modal-sendbp-body-tip">
            <div class="modal-sendbp-body-tip-title">温馨提示</div>
            <div class="modal-sendbp-body-tip-desc">疯狂BP作为信息交易平台进行发布，不对任任何用户及投资人提供任何保障，无论是商业计划是的解答、和投资人的见面。用户应依其独立判断做出</div>
          </div>
        </div>
        <div v-if="step_===4" class="modal-sendbp-body-finish">
          完成付款后请根据您的情况点击下面的按钮
        </div>
        <div v-if="step_===5" class="modal-sendbp-body-finish">
          付款已完成
        </div>
      </div>
      <div slot="footer" class="modal-sendbp-footer">
        <!-- left button -->
        <BaseButton3 v-if="step_<=1" class="modal-sendbp-footer-button" @click="close" :type="2">{{lang.cancel}}</BaseButton3>
        <BaseButton3 v-if="step_>1 && step_<=3" class="modal-sendbp-footer-button" @click="prev" :type="2">{{lang.prev}}</BaseButton3>
        <BaseButton3 v-if="step_===4" class="modal-sendbp-footer-button" @click="repay" :type="2">{{lang.finish_cancel}}</BaseButton3>
        <!-- right button -->
        <BaseButton3 v-if="list.length<=0" class="modal-sendbp-footer-button" @click="create">{{lang.create}}</BaseButton3>
        <BaseButton3 v-if="list.length>0 && step_<3" class="modal-sendbp-footer-button" @click="next">{{lang.next}}</BaseButton3>
        <BaseButton3 v-if="list.length>0 && step_===3" class="modal-sendbp-footer-button" @click="pay">{{lang.pay}}</BaseButton3>
        <BaseButton3 v-if="list.length>0 && step_===4" class="modal-sendbp-footer-button" @click="finish">{{lang.finish}}</BaseButton3>
      </div>
      <div slot="right" v-if="showDesc" class="modal-sendbp-desc">
        <div class="modal-sendbp-desc-close" @click="showDesc=false">收起</div>
        <div class="modal-sendbp-desc-title">付费投递说明</div>
        <div class="modal-sendbp-desc-desc1">
          付费向投资人投递BP后，不仅有可能获得投资人亲自回复，更有可能促成投资机会。因此我们建议您简单介绍项目亮点，提出与项目有关的问题
        </div>
        <div class="modal-sendbp-desc-desc2">
          投资人回复后才会进行扣费；若投资人一周内未给您回复，系统会将投递金退回到您的账户中
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import _ from 'lodash'
import Mem from '@/Mem.js'
import Store from '@/Store.js'
import env from '@/env.js'
import {
  nutsbpV2,
  ranch
} from '@/api'

import Avatar from 'vue-avatar'
import BaseModal from './BaseModal.vue'

import Flow123 from '../Flow123.vue'
import Close from '../Close.vue'
import {
  BaseButton3,
  BaseButton5
} from '../button'
import { BaseInput } from '../input'
export default {
  components: {
    Avatar,
    BaseModal,
    Flow123,
    Close,
    BaseButton3,
    BaseButton5,
    BaseInput
  },
  props: {
    step: { // init step
      type: Number,
      default: 1
    },
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑基本信息',
          cancel: '取消',
          create: '创建',
          prev: '上一步',
          next: '下一步',
          step2: '个人资料',
          step3: '创业问题说明',
          username: '姓名',
          mobile: '手机号',
          weixin: '微信',
          email: '邮箱',
          p_name: '项目名称',
          desc: '介绍自己当前的情况',
          upload: '上传附件',
          pay: '付款',
          finish: '付款成功',
          finish_cancel: '失败，重新支付'
        }
      }
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      cardInfo: null,
      showDesc: false,
      selectedIndex: null,
      step_: this.step,
      temp: {
        attachments: []
      },
      input: {
        attachments: []
      },
      list: [],
      timerId: null,
      isPolling: false,
      requiredAttrs: {
        step1: [],
        step2: [
          'username',
          'mobile',
          'weixin',
          'email'
        ],
        step3: [
          'p_name',
          'desc'
        ]
      }
    }
  },
  computed: {
    styleModal () {
      return `${this.height};${this.width};`
    },
    height () {
      if (this.step_ === 1) {
        return '519px' // 537 - 18
      }
      if (this.step_ === 2) {
        return '479px' // 477 + 30 - 18
      }
      if (this.step_ === 3) {
        return '714px'
      }
      return '408px'
    },
    width () {
      if (this.showDesc) {
        return '600px'
      }
      return '400px'
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    create () { this.$emit('create') },
    prev () {
      this.step_--
    },
    next () {
      switch (this.step_) {
        case 1:
          if (this.selectedIndex === null) {
            return
          }
          break
        case 2:
          for (let k of this.requiredAttrs.step2) {
            if (!this.input[k]) {
              return
            }
          }
          // 若是 瘋狂bp 資料是空白的則直接寫進去
          // @see https://github.com/nutspie/doc/blob/master/nutsbp/v2.0/user/:user_id.md#%E6%9B%B4%E6%96%B0%E4%B8%AA%E4%BA%BA%E8%B5%84%E8%AE%AF
          if (this.cardInfo !== null) {
            let params = {}
            if (!_.get(this.cardInfo, 'realname')) {
              params.realname = this.input.username
            }
            if (!_.get(this.cardInfo, 'phone')) {
              params.phone = this.input.mobile
            }
            if (!_.get(this.cardInfo, 'weixin')) {
              params.weixin = this.input.weixin
            }
            if (!_.get(this.cardInfo, 'email')) {
              params.email = this.input.email
            }
            if (Object.keys(params).length > 0) {
              nutsbpV2.patch(`/user/${Mem.get('nutsbp.unis')}`, params, {
                headers: {
                  Authorization: `nutsbp-token ${Store.get('u')}`,
                  'x-nuts-version': `dartcome-pr ${env.version}`,
                  'x-nuts-device': '3'
                }
              })
            }
          }
          break
        case 3:
          for (let k of this.requiredAttrs.step3) {
            if (!this.input[k]) {
              return
            }
          }
          break
      }
      this.step_++
    },
    /**
     * 上传图片相关
     */
    emitUpload (event) {
      document.getElementById('modal-sendbp-body-upload-files-file').click()
    },
    async addTempAtt (event) {
      let oFile = event.target.files[0]
      if (!oFile || !oFile.type) {
        throw new Error('请选择正确格式')
      }
      let mb = 10
      let iMaxFilesize = 1048576 * mb
      if (oFile.size > iMaxFilesize) {
        throw new Error(`档案尺寸超出 ${mb}MB 上限`)
      }
      let length = this.temp.attachments.push(oFile)
      let i = length - 1
      try {
        let formData = new FormData()
        formData.append('ranch.deliver.attachment', oFile)
        let res = await ranch.post('/tephra/ctrl-http/upload', formData)
        if (_.get(res, 'data[0].success') !== true) {
          let msg = _.get(res, 'data[0].message', 'upload failed')
          throw new Error(msg)
        }
        this.input.attachments[i] = res.data[0]

        oFile.uploaded = true
        // 強制刷新
        this.temp.attachments.splice(i, 1, oFile)
      } catch (e) {
        console.error(e)
        this.temp.attachments.splice(i, 1)
      }
    },
    deleteTempAtt (row, i) {
      this.temp.attachments.splice(i, 1)
      if (this.input.attachments[i]) {
        this.input.attachments.splice(i, 1)
      }
    },
    clearTimer () {
      clearTimeout(this.timerId)
      this.timerId = null
      this.isPolling = false
    },
    startCheckListener (uuid) {
      if (this.isPolling) {
        return
      }
      if (this.timerId !== null) {
        return
      }
      this.isPolling = true
      let interval = 5000
      let fn = () => {
        this.timerId = setTimeout(async () => {
          let status = await this.checkPayStatus(uuid)
          if (status === 1 || status === 2) {
            this.next()
          } else {
            fn()
          }
        }, interval)
      }
      fn()
    },
    async checkPayStatus (uuid) {
      try {
        let params = {
          id: uuid
        }
        let res = await ranch.post('/deliver/find', params, {
          headers: {
            'tephra-session-id': Store.get('sid')
          }
        })
        let status = _.get(res, 'data.data.state')
        return status
      } catch (e) {
        return null
      }
    },
    async pay () {
      for (let step of Object.keys(this.requiredAttrs)) {
        for (let k of this.requiredAttrs[step]) {
          if (!this.input[k]) {
            return
          }
        }
      }
      // 寫入暫存
      let input = {}
      for (let k of this.requiredAttrs.step2) {
        input[k] = this.input[k]
      }
      Store.set('temp.SendBpModal.input', input)

      let el = window.open('', '_blank')
      try {
        // create 訂單
        let params = {
          investor: _.get(this.data, 'uuid'),
          investorName: _.get(this.data, 'card.name'),
          investorAccount: _.get(this.data, 'account'),
          sender: Mem.get('nutsbp.uuid'),
          // price: this.deliverPrice, // TODO 訂單應該不需要這個值
          name: this.input.username,
          mobile: this.input.mobile,
          weixin: this.input.weixin,
          email: this.input.email,
          slideId: this.list[this.selectedIndex].slide_id,
          bpName: this.input.p_name,
          memo: this.input.desc,
          attachments: JSON.stringify(this.input.attachments)
        }

        let res = await ranch.post('/deliver/create', params, {
          headers: {
            'tephra-session-id': Store.get('sid')
          }
        })
        if (_.get(res, 'data.code') !== 0) {
          throw new Error(_.get(res, 'data.msg'))
        }
        let data = _.get(res, 'data.data')
        // /**
        //  * @see https://github.com/nutspie/doc/blob/master/nutsbp/nutsbp-v3.md
        //  * 例:https://edit.nutsbp.com/?u=token/#bpBill/${bill_id}/returnUrl=${returnUrl}
        //  */
        let url = `${env.editorUrlV4}/?u=${Store.get('u')}/#bpBill/${data.id}`
        console.log(data, url)
        el.location.href = url
        this.next()

        // 監聽是否付款完成
        this.clearTimer()
        this.startCheckListener(data.id)
      } catch (e) {
        console.error(e)
        el.close()
      }
    },
    repay () {
      this.prev()
      this.clearTimer()
      this.pay()
    },
    finish () {
      console.log('finish')
    },
    async fetchDetailInfo () {
      let res = await nutsbpV2.get(`/user/${Mem.get('nutsbp.unis')}/cardinfo`, {
        headers: {
          Authorization: `nutsbp-token ${Store.get('u')}`,
          'x-nuts-version': `dartcome-pr ${env.version}`,
          'x-nuts-device': '3'
        }
      })
      return _.get(res, 'data.data')
    }
  },
  async mounted () {
    let res = await nutsbpV2.get('/slide', {
      headers: {
        Authorization: `nutsbp-token ${Store.get('u')}`,
        'x-nuts-version': `dartcome-pr ${env.version}`,
        'x-nuts-device': '3'
      }
    })
    let list = _.filter(_.get(res, 'data.data'), { 'orientation': 2 })
    this.list = _.orderBy(list, ['update_time'], ['desc'])

    let input = Store.get('temp.SendBpModal.input')
    if (input) {
      this.input = _.merge({}, this.input, input)
    } else {
      let data = await this.fetchDetailInfo()
      this.input.username = _.get(data, 'realname')
      this.input.mobile = _.get(data, 'phone')
      this.input.email = _.get(data, 'email')
      this.input.weixin = _.get(data, 'weixin')

      this.cardInfo = data
    }
  },
  watch: {
    selectedIndex (newV, oldV) {
      if (newV > -1) {
        this.input.p_name = this.list[this.selectedIndex].name
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.modal-sendbp {
  & input[type="checkbox"], & input[type="radio"] {
    transform:scale(2, 2);
  }
  & .modal-sendbp-close {
    position: absolute;
    right: -35px;
    top: -25px;
  }
  & .modal-sendbp-container {
    min-height: 400px;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: var(--colorWhite);
    height: fit-content;
    border-radius: var(--borderRadius1);

    & .modal-sendbp-header {
      width: 400px;
      & .modal-sendbp-header-desc {
        padding: 15px;
        color: var(--colorMain);
        right: 0;
        position: absolute;
        cursor: pointer;
        & .modal-sendbp-header-desc-text {
          display: inline-block;
        }
        & .modal-sendbp-header-desc-arrow {
          display: inline-block;
          margin-left: 8px;
          width: 6px;
          height: 10px;
          background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_arrow_explain.png');
          background-repeat: no-repeat;
        }
      }
      & .modal-sendbp-header-flow {
        padding-top: 50px;
        padding-bottom: 29px;
      }
    }
    & .modal-sendbp-body {
      width: 400px;
      text-align: center;
      & .modal-sendbp-body-bg {
        height: 112px;
        background-position: center;
        background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_bp_illustration.png');
        background-repeat: no-repeat;
      }
      & .modal-sendbp-body-title {
        font-weight: bold;
        font-size: var(--textSize3);
        padding-bottom: calc(30px - 7px);
      }
      & .modal-sendbp-body-create {
        margin-top: 20px;
      }
      & .modal-sendbp-body-select {
        width: 340px;
        height: calc(295px - 20px);
        margin: 0 30px;

        border-radius: var(--borderRadius1);
        border: 1px solid var(--colorDisabled);

        overflow-y: scroll;

        & .modal-sendbp-body-select-item {
          padding: 10px 0;
          margin: 0 10px;
          min-height: 50px;
          position: relative;
          & .modal-sendbp-body-select-item-img {
            position: absolute;
            left: 0;
          }
          & .modal-sendbp-body-select-item-desc {
            text-align: left;
            margin-left: calc(50px + 20px);
            & .modal-sendbp-body-select-item-desc-title {
              padding-top: 7px;
              font-weight: bold;
              font-size: var(--textSize3);
            }
            & .modal-sendbp-body-select-item-desc-time {
              padding-top: 9px;
              color: var(--colorGray1);
            }
          }
          & .modal-sendbp-body-select-item-check {
            position: absolute;
            right: 40px;
            top: calc(10px + 50px / 2 - 18px / 2);
            & input {
              cursor: pointer;
            }
          }
        }
      }
      & .modal-sendbp-body-input {
        height: 36px;
        margin-right: 61px;
        padding: 7px 0;
        & .modal-sendbp-body-input-title {
          position: relative;
          top: 10px;
          display: inline-block;
          width: 100px;
          margin-right: 10px;
          text-align: right;
          & .modal-sendbp-body-input-title-star {
            color: var(--colorError);
          }
        }
      }
      & .modal-sendbp-body-input2 {
        padding: 8px 0;
        & .modal-sendbp-body-input2-title {
          margin: 7px 30px;
          position: relative;
          text-align: left;
          & .modal-sendbp-body-input2-title-star {
            color: var(--colorError);
          }
        }
      }
      & .modal-sendbp-body-upload {
        position: relative;
        width: 340px;
        height: 65px;
        margin: 8px 30px;
        & .modal-sendbp-body-upload-files {
          text-align: left;
          font-size: var(--textSize5);
          width: 248px;
          height: 100%;
          border-radius: var(--borderRadius3);
          border: 1px dashed var(--colorGray3);
          overflow-y: scroll;

          & .modal-sendbp-body-upload-files-file {
            display: inline-block;
            padding: 10px 0;
            margin: 0 15px;
          }
          & .red {
            color: var(--colorError);
          }
        }
        & .modal-sendbp-body-upload-button {
          position: absolute;
          top: 0;
          right: 0;
          font-size: var(--textSize5);
          padding: 0;
          width: 62px;
        }
      }
      & .modal-sendbp-body-private {
        text-align: left;
        position: relative;
        margin: 0 30px;
        padding: 8px 0;
        & .modal-sendbp-body-private-title {
          padding-bottom: 8px;
          color: var(--colorGray0);
        }
        & .modal-sendbp-body-private-desc {
          font-size: var(--textSize5);
          color: var(--colorGray1);
        }
        & .modal-sendbp-body-private-check {
          margin-top: 10px;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      & .modal-sendbp-body-tip {
        margin: 8px 30px;
        text-align: left;
        & .modal-sendbp-body-tip-title {
          padding-bottom: 8px;
          color: var(--colorGray0);
        }
        & .modal-sendbp-body-tip-desc {
          font-size: var(--textSize5);
          color: var(--colorGray1);
          background-color: var(--colorWhite1);
          padding: 12px;
        }
      }
      & .modal-sendbp-body-finish {
        font-size: var(--textSize3);
        padding: 67px;
      }
    }
    & .modal-sendbp-footer {
      width: 400px;
      text-align: center;
      & .modal-sendbp-footer-button {
        margin: 35px 20px;
        width: 100px;
      }
    }

    & .modal-sendbp-desc {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;

      display: inline-block;
      width: 200px;
      color: var(--colorWhite);
      background-color: var(--colorMain);
      background-image: url('http://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_explain_backgound.png');

      & .modal-sendbp-desc-close {
        position: absolute;
        right: 0;
        padding: 15px;
        font-size: var(--textSize5);
        cursor: pointer;
      }
      & .modal-sendbp-desc-title {
        font-size: var(--textSize3);
        margin: 0 23px;
        padding-top: 50px;
      }
      & .modal-sendbp-desc-desc1 {
        margin: 0 23px;
        padding-top: 35px;
      }
      & .modal-sendbp-desc-desc2 {
        margin: 0 23px;
        padding-top: 48px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/SendBpModal.vue